import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from '../../services/form.service';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';

declare let bootbox: any;

@Component({
	selector: 'login-page',
	templateUrl: './login.html',
	styleUrls: ['./login.css']
})
export class LoginPage {
	public form: FormGroup;

	public constructor(
		formBuilder: FormBuilder,
		private _form: FormService,
		private data: DataService,
		private router: Router
	) {
		this.form = formBuilder.group({
			email: ['', Validators.compose([Validators.required, Validators.email])],
			password: ['', Validators.required]
		});

		this._form.setForm(this.form);
	}

	public onSubmit(event) {
		event.preventDefault();

		if(!this.form.valid) {
			this._form.showErrors();
		}
		else {
			this.data.user.login(this.form.value)
			.then(() => {
				this.router.navigate(['/dashboard']);
			});
		}

	}
}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts